<div class="black_screen" *ngIf="bool_blck_screen"></div>

<div class="cls_red">
    <p>Click and update - To download / Update institute student list</p>
    <!-- <p>View and Select - To select & genrate payment reference </p> -->
</div>

<button class="btn btn-primary small-btn" (click)="fn_click_updt()">Click and Update</button>
<!-- <button class="btn btn-primary small-btn" (click)="fn_show_view_selct()">View and Select</button> -->

<!--Click and Update Table Start-->
<div class="row" *ngIf="bool_list_table">
    <div class="col-md-12">
        <div class="example-container mat-elevation-z8 tableStud">
            <mat-table #table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="slno">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> # </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index;"> {{element.id}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="iticode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Code </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.iticode}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.itiname}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="district">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.district}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="update">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Count </mat-header-cell>
                    <mat-cell *matCellDef="let element">{{element.count}} <button class="btn btn-primary small-btn"
                            (click)="selected_family_member.select(element)" (click)="updated_fn()">Update</button>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
            <mat-paginator #paginator="matPaginator" [pageSize]="5" [length]="totallength"
                (page)="pageEvent = $event; pageChanged($event)" [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]">
            </mat-paginator>
        </div>
    </div>
</div>
<!--Click and Update Table End-->

<div class="row pad-tb-10" *ngIf="bool_view_table">
    <div class="col-md-3">
        <span class="fnt-21">Total Candidates Selected: {{studcount}} </span>
    </div>
    <div class="col-md-3">
        <span class="fnt-21"> Fees Amount: {{totCount}}</span>
    </div>
    <div class="col-md-6 align-right">
        <button class="btn btn-success btn-sm btn-white" routerLink="/examfeestate/showpaytable"
            routerLinkActive="active"> Verify Your Previous Payments </button>
    </div>
</div>

<!--View and select ITI State Table Start-->
<div class="row" *ngIf="bool_iti_state_table">
    <div class="col-md-12">
        <div class="example-container mat-elevation-z8">
            <mat-table #table [dataSource]="dataSource_ITI_State" #sort_Iti_state="matSort" matSort>
                <!--Select Table-->
                <ng-container matColumnDef="select" class="mat-column-username">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Select </mat-header-cell>
                    <mat-cell *matCellDef="let element; index as i">
                        <mat-checkbox (change)="fn_select_iti_state_row($event,element, i)"
                            (change)="$event ? selected_iti_state.toggle(element) : null"
                            [checked]="selected_iti_state.isSelected(element)">
                        </mat-checkbox>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="slno">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> # </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="iticode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> ITI Code </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ITICode}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ITIName}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="count">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Count </mat-header-cell>
                    <mat-cell *matCellDef="let element;"> <button *ngIf="!view_bool_disble"
                            class="btn btn-success small-btn"> {{element.count}} open </button> <button
                            class="btn btn-success small-btn" (click)="fn_view_iti_state(element)"> {{element.count}} View
                        </button> </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns_iti_state"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns_iti_state;  let i = index"></mat-row>
            </mat-table>
            <!-- <mat-paginator #paginator_Iti_state="matPaginator"  [length]="totallength_ITI_State" [pageSizeOptions]="[ 5,10, 25]"></mat-paginator> -->
        </div>

        <div class="row pad-tb-10">
            <div class="col-md-12 align-right">
                <!-- <button class="btn btn-success small-btn" [disabled]="bool_paynow"  (click)="offln_form_fn()"> Pay Offline </button> -->
                <!-- <button class="btn btn-success small-btn" (click)="fn_paynow()"> Pay Now </button> -->
            </div>
            <p> Before selecting paynow Kindly ensure that the candidate selected are correct. After selecting paynow
                changes in selected candidates cannot be made</p>

        </div>
    </div>
</div>
<!--View and select ITI State Table End-->

<div class="container-fluid">
    <div class="card-body " *ngIf="bool_popup">

        <div class="row pad-tb-10">
            <div class="col-md-12">
                <div class="align-right">
                    <button class="btn btn-danger" (click)="close_fn()">X</button>
                </div>
            </div>
            <div class="col-md-6">
                Name: {{itiNameView}} <br>
                ITI Code: {{itiCodeView}} <br>
            </div>
            <!-- <div class="col-md-6">
                Email: {{itiHeaderemail}} <br>
                Mobile: {{itiHeaderMobile}} <br>    
            </div> -->
        </div>

        <div class="row popup-view">
            <div class="col-md-12">

                <div class="example-container mat-elevation-z8 tableStud">
                    <mat-table #table [dataSource]="dataSource_ITI_Student" matSort>
                        <!--View Table-->
                        <ng-container matColumnDef="select" class="mat-column-username">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                <mat-checkbox (change)="$event ? fn_masterToggle($event) : null"
                                    [checked]="fn_isAllSelected_student()"
                                    [indeterminate]="selected_family_member_District.hasValue() && !fn_isAllSelected_student()">
                                    Select All
                                </mat-checkbox>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="fn_select_iti_student($event,element)"
                                    (change)="$event ? selected_family_member_District.toggle(element) : null"
                                    [checked]="fn_isSelected_student(element)">
                                </mat-checkbox>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="slno">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> # </mat-header-cell>
                            <mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="rollnumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Register Number </mat-header-cell>
                            <mat-cell *matCellDef="let element; let i = index;"> {{element.RollNumber}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.TraineeName}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="trade">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Trade </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.Trade}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="exam">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Exam </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.Exam}} </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="displayedColumnsDistrict"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumnsDistrict;"></mat-row>
                    </mat-table>
                    <!-- <mat-paginator  #paginator="matPaginator" [pageSize]="5" [length]="totallength" [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]"></mat-paginator> -->
                </div>

            </div>
        </div>

    </div>
</div>

<pre style="display: none;">
    selection.hasValue(): {{selected_family_member_District.hasValue()}}
    fn_isAllSelected_student(): {{fn_isAllSelected_student()}}
</pre>

<!--View and select ITI student Table Start-->

<div class="row" *ngIf="bool_offline_form">
    <div class="col-md-12">

        <div class="card-body">


            <form [formGroup]="nimiForm" (ngSubmit)="onnimiSubmit()">
                <div class="form-row">
                    <div class="form-group col-4">
                        <label>Payment Mode <span class="clr_red"> * </span></label>
                        <select formControlName="paymode" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.paymode.errors }">
                            <option [selected]="true" value="" [disabled]="true">Select Pay mode
                            </option>
                            <option value="Demand Draft">Demand Draft</option>
                            <option value="RTGS">RTGS</option>
                            <option value="Bank Deposit">Bank Deposit</option>
                            <option value="Account Transfer">Account Transfer</option>
                        </select>
                        <div *ngIf="submitted && f.paymode.errors" class="invalid-feedback">
                            <div *ngIf="f.paymode.errors.required">Select Your Pay mode</div>
                        </div>
                    </div>
                    <div class="form-group col-4">
                        <label>Reference Number <span class="clr_red"> * </span></label>
                        <input type="text" formControlName="refno" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.refno.errors }" maxlength="20"
                            placeholder="Enter Your Reference Number" (keypress)="omit_spl($event)" />
                        <div *ngIf="submitted && f.refno.errors" class="invalid-feedback">
                            <div *ngIf="f.refno.errors.required">Enter Your Reference Number</div>
                        </div>
                    </div>
                    <div class="form-group col-4">
                        <label>Amount <span class="clr_red"> * </span></label>
                        <input type="text" formControlName="amount" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.amount.errors }" maxlength="50"
                            placeholder="Enter Your Amount" [(ngModel)]="totCount" (keypress)="omit_number($event)"
                            readonly />
                        <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
                            <div *ngIf="f.amount.errors.required">Enter Your Amount</div>
                        </div>
                    </div>
                    <div class="form-group col-4">
                        <label>Date <span class="clr_red"> * </span></label>
                        <input type="date" formControlName="date" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.date.errors }" maxlength="50"
                            placeholder="Enter Your Date" (keypress)="omit_spl($event)" />
                        <div *ngIf="submitted && f.date.errors" class="invalid-feedback">
                            <div *ngIf="f.date.errors.required">Enter Your Date</div>
                        </div>
                    </div>
                    <div class="form-group col-4">
                        <label>State <span class="clr_red"> * </span></label>
                        <input type="text" formControlName="state" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.state.errors }" maxlength="50"
                            placeholder="Enter Your State Name" [(ngModel)]="reciveeITIStateName" readonly />
                        <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                            <div *ngIf="f.state.errors.required">Enter Your State</div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="form-row">
                    <div class="form-group col-12">
                        <div class="text-center">
                            <button [disabled]="bool_offln_submit" class="btn btn-primary mr-1">Submit</button>
                        </div>
                        <!-- <div *ngIf="bool_spinner" class="bg-overlay_cls"> Please Wait...  </div> -->
                    </div>
                </div>
            </form>

        </div>
    </div>
</div>

<!--View and select ITI student Table End-->

<p> {{seltable}} </p>